<template>
  <div id="hubspotForm" v-once ref="hubspotForm">
    <div
      class="meetings-iframe-container"
      data-src="https://meetings.hubspot.com/marc-aas/marketing-hack-round-robin?embed=true"
    ></div>
  </div>
</template>

<script>
export default {
  methods: {
    handleMessage(event) {
      if (event.data.meetingBookSucceeded == true) {
        this.$emit("form-succeeded");
      }
    }
  },
  mounted() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    this.$refs.hubspotForm.appendChild(script);
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  }
};
</script>
